// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiselect {
  color: #495057;
}

.multiselect .multiselect__tags {
  font-size: 1rem;
  min-height: unset;
}

[dir] .multiselect .multiselect__tags {
  border-color: #ced4da;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
}

[dir] .multiselect .multiselect__tags .multiselect__tag {
  background-color: #662583;
  margin-top: 3px;
  margin-bottom: -3px;
}

.multiselect .multiselect__tags .multiselect__tag-icon:after {
  color: #f8f9fa;
}

[dir] .multiselect .multiselect__tags .multiselect__tag-icon:hover {
  background: #571f6f;
}

.multiselect .multiselect__tags .multiselect__placeholder {
  color: #6c757d;
}

[dir] .multiselect .multiselect__tags .multiselect__placeholder {
  margin-bottom: 0;
  padding: 0;
}

.multiselect .multiselect__tags .multiselect__input, .multiselect .multiselect__tags .multiselect__single {
  line-height: 1.5;
}

[dir] .multiselect .multiselect__tags .multiselect__input, [dir] .multiselect .multiselect__tags .multiselect__single {
  padding: 0;
  margin-bottom: 0;
}

[dir] .multiselect .multiselect__option--highlight {
  background-color: #662583;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
